/*
Alerts Baumplot 1
*/
import React, { useContext, useState } from "react";

import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Button from "@mui/material/Button";
import { AppContext } from "../../AppContext";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

function Baumplot1Alert() {
  const appContext = useContext(AppContext);
  const [lessThanFive, setLessThanFive] = useState(false);

  return (
    <>
      <Alert
        severity="warning"
        style={{
          flexWrap: "wrap",
          flexDirection: "row wrap",
          //margin: "0",
          alignItems: "center",
          justifyContent: "center",
          position: "absolute",
          bottom: "40%",
          zIndex: "505",
        }}
      >
        <AlertTitle>
          Ihre Eingaben sind nicht vollständig.<br></br> Bitte überprüfen Sie,
          ob zu jedem Baum <strong>alle</strong> Angaben vorgenommen wurden.
          <br></br>
          Und ob Sie unter Transektanlage den <strong>Azimut</strong> angegeben
          haben.
        </AlertTitle>
        <br></br>
        {appContext.baumplot1ZeroRowsCheck && (
          <div>
            <FormControlLabel
              control={<Checkbox />}
              label="Es sind keine Bäume vorhanden"
              value={lessThanFive}
              onClick={(event) => {
                appContext.setBaumplot1ZeroRows(true);
              }}
            />
            <br></br>
          </div>
        )}
        {appContext.baumplot1RowCountCheck && (
          <FormControlLabel
            control={<Checkbox />}
            label="Es sind weniger als 5 Bäume vorhanden"
            value={lessThanFive}
            onClick={(event) => {
              setLessThanFive(lessThanFive);
              appContext.setBaumplotLessThanFive(true);
            }}
          />
        )}
        <br></br>
        <Button
          variant="outlined"
          onClick={() => {
            if (appContext.baumplot1Check === true) {
              appContext.setCurrentTab("BAUMPLOT");
              appContext.setCurrentSubTab("BAUMPLOT 2");
            }
            appContext.setShowBaumplot1Alert(false);
          }}
        >
          Die Angaben sind vollständig
        </Button>
        <Button
          style={{ marginLeft: "10px" }}
          variant="outlined"
          onClick={() => {
            setLessThanFive(false);
            appContext.setShowBaumplot1Alert(false);
            appContext.setBaumplotLessThanFive(false);
            appContext.setBaumplot1ZeroRowsCheck(false);
          }}
        >
          Abbrechen
        </Button>
      </Alert>
    </>
  );
}
export default Baumplot1Alert;
